<template>
    <v-dialog v-model="showPopUp" persistent max-width="500">
        <div class="grid-item">
            <v-row
                class="ma-0 px-0 pb-2 pt-0 border-bottom center-container-vertically"
            >
                <p class="h400 center-align-text">
                    {{ t("alerts.sessionExpiring") }}
                </p>
            </v-row>

            <v-row class="ma-0 px-4 pt-2">
                <p>
                    {{
                        t("alerts.sessionInactiveWarning", {
                            seconds: countdown,
                        })
                    }}
                </p>
            </v-row>

            <v-row class="mx-0 mt-2 px-0 pt-2 pb-4 center-container-vertically">
                <default-button
                    btn-style="default-btn small-default-btn secondary-btn"
                    @run-method="handleStaySignedIn"
                    text-style="h200 white-text"
                    text="Stay signed in"
                />
            </v-row>
        </div>
    </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import defaultButton from "@/components/buttons/defaultButton.vue";

const { t } = useI18n();

const props = defineProps<{
    dialogVisible: boolean;
    countdown: number;
}>();

const emit = defineEmits<{
    (e: "update:dialogVisible", value: boolean): void;
    (e: "stay-signed-in"): void;
}>();

const showPopUp = computed({
    get: () => props.dialogVisible,
    set: (value) => emit("update:dialogVisible", value),
});
const countdown = computed(() => props.countdown);

/**
 * Handle user clicking "Stay signed in". Emit event to parent and close the dialog
 * @returns {void}
 * */
const handleStaySignedIn = (): void => {
    emit("stay-signed-in");
    showPopUp.value = false;
};
</script>
